import canShowField from './canShowField';

function readLayoutState(fieldLayout) {
  return fieldLayout?.state ?? fieldLayout?.State ?? 'padrao';
}

export function isVigenteLayout(fieldLayout) {
  return String(readLayoutState(fieldLayout)).toLowerCase() === 'vigente';
}

export function readLoggedRoleId() {
  const storedPermissions = localStorage.getItem('conecta__permissions');
  if (!storedPermissions) {
    return null;
  }

  return JSON.parse(storedPermissions)?.id;
}

export function readPortalResource(resourceName) {
  const storedPermissions = localStorage.getItem('conecta__permissions');
  if (!storedPermissions) {
    return { resourceId: undefined, resourceName };
  }

  const role = JSON.parse(storedPermissions);
  const resource = role?.resources?.find((item) => item.name === resourceName);
  return {
    resourceId: resource?.id,
    resourceName: resource?.name ?? resourceName,
  };
}

export function shouldRenderTaskField({
  fieldName,
  fieldsPermissions,
  fieldLayout,
  roleId,
  fieldNameFilter,
}) {
  if (fieldNameFilter && fieldNameFilter !== fieldName) {
    return false;
  }

  return canShowField({
    fieldName,
    fieldPermissions: fieldsPermissions,
    layoutState: readLayoutState(fieldLayout),
    roleId,
  });
}

export function createShowField(fieldsPermissions, fieldLayout, roleId, fieldNameFilter) {
  return (fieldName) =>
    shouldRenderTaskField({
      fieldName,
      fieldsPermissions,
      fieldLayout,
      roleId,
      fieldNameFilter,
    });
}

export function readLayoutField(item) {
  return {
    name: item?.name ?? item?.Name,
    label: item?.label ?? item?.Label,
    fieldType: item?.fieldType ?? item?.FieldType ?? null,
    accessHint: item?.accessHint ?? item?.AccessHint,
  };
}

export function readLayoutSections(fieldLayout) {
  return fieldLayout?.sections ?? fieldLayout?.Sections ?? [];
}

export function readLayoutUnsectioned(fieldLayout) {
  return fieldLayout?.unsectioned ?? fieldLayout?.Unsectioned ?? [];
}
